// extracted by mini-css-extract-plugin
export default {"iframe":"gvm5TL","fillAllSpace":"d3CoQu","absolute":"rAMlL0"};